<style lang="stylus">
    .focus-tool-textaligncontainer
        background #fff
        padding-bottom 8px
        border-bottom-left-radius 5px
        border-bottom-right-radius 5px
        width 155px
        .imgbox-list
            width 144px
            padding: 16px;
            border-radius 5px
            background-color $navigation-modal-bgcolor
            border-radius 5px
            box-shadow $common-box-shadow
            box-sizing border-box
            z-index 1
            position absolute
            top 36px
            display grid
            grid-template-columns repeat(3, 1fr)

            .align-line {
                    grid-column-start 1;
                    grid-column-end 4;
                    margin 12px 0;
                    list-style none
                    border-top 1px solid var(--border-color-float-hv-line)
                }
            .imgbox-li
                display: flex;
                justify-content center;
                align-items center;
                list-style none
                width 32px
                height 32px
                box-sizing border-box
                user-select none
                cursor pointer
                margin-right 8px
                position: relative;
                border-radius: $box-radius;

                &:nth-child(4n)
                    margin-right 0

                &:not(.active):hover
                    background-color $main-hovercolor
                &.active
                    background-color $main-selectcolor
                .item-icon
                    width 24px
                    height 24px
                    color: var(--svg-color-gray-42)
</style>

<template>
    <DragBox
        :dragTitle="dragTitle"
        :originPostion="{ left: `${originPostion.left}px`, top: `${originPostion.top}px` }"
        :style="{ left: `${originPostion.left}px`, top: `${originPostion.top}px` }"
        :showModal="showModal"
        :lockBox="lockBox"
        @changeLock="changeLock($event)"
        @updateBoxPos="updateBoxPos($event)"
        @removeCloseEvent="removeCloseListener()"
        @closeBox="closeEvent()"
    >
        <div class="focus-tool-textaligncontainer">
            <ul class="imgbox-list">
                <li
                    class="imgbox-li"
                    :class="{ active: item.id == fontAlignHActiveID }"
                    v-for="item in fontAlignHList"
                    :key="`${item.id}-h`"
                    @click.stop="clickAlign('h', item.id)"
                    :content="$t(`tipsList.${item.name}`)"
                    v-tippy="{ placement: 'bottom' }"
                >
                    <iconSymbol class="item-icon" :name="item.name"></iconSymbol>
                </li>
                <li class="align-line"></li>
                <li
                    class="imgbox-li"
                    :class="{ active: item.id == fontAlignVActiveID }"
                    v-for="item in fontAlignVList"
                    :key="`${item.id}-v`"
                    @click.stop="clickAlign('v', item.id)"
                    :content="$t(`tipsList.${item.name}`)"
                    v-tippy="{ placement: 'bottom' }"
                >
                    <iconSymbol class="item-icon" :name="item.name"></iconSymbol>
                </li>
            </ul>
        </div>
    </DragBox>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import DragBox from "../Tabs/NavigationDragBox.vue";
    import fontTool from "@/app/mixin/fontTool";

    @Component({
        components: {
            DragBox,
        },
    })
    export default class FocusExpandToolLayer extends fontTool {
        @Prop()
        index;
        @Prop()
        dragTitle;
        @Prop()
        showModal;
        @Prop()
        originPostion;
        @Prop()
        lockBox;

        fontAlignHList: Array<{ id: number; text: string; name: string }> = [
            {
                id: 0,
                text: "",
                name: "centerleft",
            },
            {
                id: 1,
                text: "",
                name: "center",
            },
            {
                id: 2,
                text: "",
                name: "centerright",
            },
        ];
        fontAlignVList: Array<{ id: number; text: string; name: string }> = [
            {
                id: 0,
                text: "",
                name: "topaside",
            },
            {
                id: 1,
                text: "",
                name: "centeraside",
            },
            {
                id: 2,
                text: "",
                name: "bottomaside",
            },
        ];
        clickAlign(type, i) {
            let alignText = [
                ["left", "top"],
                ["center", "top"],
                ["right", "top"],
                ["justify", "top"],
                ["left", "middle"],
                ["center", "middle"],
                ["right", "middle"],
                ["justify", "middle"],
                ["left", "bottom"],
                ["center", "bottom"],
                ["right", "bottom"],
                ["justify", "bottom"],
            ];
            let v = type === "v" ? i : this.fontAlignVActiveID;
            let h = type === "h" ? i : this.fontAlignHActiveID;
            let index = this.getRealAlignId(v, h);
            window["_view"].editStyle("align", alignText[index]);
        }

        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }

        get customSet() {
            return this.$store.state.ui.defaultFontType == 1;
        }
        get ignoreDefFont() {
            return this.$store.state.page.ignoreDefFont;
        }

        get fontAlignActiveID() {
            if (this.isSelect) return this.$store.state.shape.fontFmt.align;
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultAlign;
            else return this.$store.state.page.themeTextAlign;
        }

        get fontAlignVActiveID() {
            return this.getRenderAlignID(this.fontAlignActiveID).vAlign;
        }

        get fontAlignHActiveID() {
            return this.getRenderAlignID(this.fontAlignActiveID).hAlign;
        }

        updateBoxPos(pos) {
            this.$emit("updateBoxPos", pos);
        }
        changeLock(e) {
            e && this.$emit("changeLock", this.index);
        }
        removeCloseListener() {
            this.$emit("removeCloseEvent", this.index);
        }
        closeEvent() {
            this.$emit("closeBox", this.index);
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "tipsList": {
      "topleft": "顶部左对齐",
      "topcenter": "顶部居中",
      "topright": "顶部右对齐",
      "topaside": "顶部两端对齐",
      "centerleft": "居中左对齐",
      "center": "居中",
      "centerright": "居中右对齐",
      "centeraside": "居中两端对齐",
      "bottomleft": "底部左对齐",
      "bottomcenter": "底部居中",
      "bottomright": "底部右对齐",
      "bottomaside": "底部两端对齐"
    }
  },
  "en": {
    "tipsList": {
      "topleft": "Top Align Left",
      "topcenter": "Top Center",
      "topright": "Top Align Right",
      "topaside": "Top Justified",
      "centerleft": "Center Align Left",
      "center": "Center",
      "centerright": "Center Align Right",
      "centeraside": "Center Justified",
      "bottomleft": "Bottom Align Left",
      "bottomcenter": "Bottom Center",
      "bottomright": "Bottom Align Right",
      "bottomaside": "Bottom Justified"
    }
  },
  "fr": {
    "tipsList": {
      "topleft": "En haut à gauche aligné",
      "topcenter": "Haut centre",
      "topright": "En haut à droite aligné",
      "topaside": "Aligner les extrémités de haut",
      "centerleft": "Centré à gauche aligné",
      "center": "Centre",
      "centerright": "Centré à droite aligné",
      "centeraside": "Aligner les extrémités au centre",
      "bottomleft": "En bas à gauche aligné",
      "bottomcenter": "Bas centré",
      "bottomright": "En bas à droite aligné",
      "bottomaside": "Aligner les extrémités en bas"
    }
  },
  "de": {
    "tipsList": {
      "topleft": "Oben linksbündig",
      "topcenter": "Oben mittig",
      "topright": "Oben rechtsbündig",
      "topaside": "Blocksatz oben",
      "centerleft": "Zentral linksbündig",
      "center": "Zentriert",
      "centerright": "Zentral rechtsbündig",
      "centeraside": "Blocksatz mittig",
      "bottomleft": "Unten linksbündig",
      "bottomcenter": "Unten mittig",
      "bottomright": "Unten rechtsbündig",
      "bottomaside": "Blocksatz unten"
    }
  },
  "jp": {
    "tipsList": {
      "topleft": "左揃え（上）",
      "topcenter": "中央揃え（上）",
      "topright": "右揃え（上）",
      "topaside": "両端揃え（上）",
      "centerleft": "左揃え（中央）",
      "center": "中央揃え",
      "centerright": "右揃え（中央）",
      "centeraside": "両端揃え（中央）",
      "bottomleft": "左揃え（下）",
      "bottomcenter": "中央揃え（下）",
      "bottomright": "右揃え（下）",
      "bottomaside": "両端揃え（下）"
    }
  },
  "es": {
    "tipsList": {
      "topleft": "Alinear arriba a la izquierda",
      "topcenter": "Centro arriba",
      "topright": "Alinear arriba a la derecha",
      "topaside": "Arriba justificado",
      "centerleft": "Alinear al centro a la izquierda",
      "center": "Centro",
      "centerright": "Alinear al centro a la derecha",
      "centeraside": "Centro Justificado",
      "bottomleft": "Alinear abajo a la izquierda",
      "bottomcenter": "Centro inferior",
      "bottomright": "Alinear abajo a la derecha",
      "bottomaside": "Abajo Justificado"
    }
  },
  "pt": {
    "tipsList": {
      "topleft": "Alinhamento Superior à Esquerda",
      "topcenter": "Centro Superior",
      "topright": "Alinhamento Superior à Direita",
      "topaside": "Justificado Superior",
      "centerleft": "Alinhar ao Centro à Esquerda",
      "center": "Centro",
      "centerright": "Alinhar ao Centro à Direita",
      "centeraside": "Justificado ao Centro",
      "bottomleft": "Alinhamento Inferior à Esquerda",
      "bottomcenter": "Centro Inferior",
      "bottomright": "Alinhamento Inferior à Direita",
      "bottomaside": "Justificado Inferior"
    }
  },
  "it": {
    "tipsList": {
      "topleft": "Allinea in Alto a Sinistra",
      "topcenter": "Allinea in Alto al Centro",
      "topright": "Allinea in Alto a Destra",
      "topaside": "Allinea in Alto Giustificato",
      "centerleft": "Allinea al Centro a Sinistra",
      "center": "Allinea al Centro",
      "centerright": "Allinea al Centro a Destra",
      "centeraside": "Allinea al Centro Giustificato",
      "bottomleft": "Allinea in Basso a Sinistra",
      "bottomcenter": "Allinea in Basso al Centro",
      "bottomright": "Allinea in Basso a Destra",
      "bottomaside": "Allinea in Basso Giustificato"
    }
  },
  "tw": {
    "tipsList": {
      "topleft": "頂部左對齊",
      "topcenter": "頂部居中",
      "topright": "頂部右對齊",
      "topaside": "頂部兩端對齊",
      "centerleft": "居中左對齊",
      "center": "居中",
      "centerright": "居中右對齊",
      "centeraside": "居中兩端對齊",
      "bottomleft": "底部左對齊",
      "bottomcenter": "底部居中",
      "bottomright": "底部右對齊",
      "bottomaside": "底部兩端對齊"
    }
  },
  "kr": {
    "tipsList": {
      "topleft": "맨 위 왼쪽 정렬",
      "topcenter": "맨 위 가운데 정렬",
      "topright": "맨 위 오른쪽 정렬",
      "topaside": "상단 정렬",
      "centerleft": "가운데에서 왼쪽 정렬",
      "center": "가운데 정렬",
      "centerright": "가운데서 오른쪽 정렬",
      "centeraside": "가운데 두 끝 정렬",
      "bottomleft": "밑바닥 왼쪽 정렬",
      "bottomcenter": "밑바닥 가운데 정렬",
      "bottomright": "밑바닥 오른쪽 정렬",
      "bottomaside": "밑바닥 양단 정렬"
    }
  }
}
</i18n>
